import { Box } from '@chakra-ui/react';
import React from 'react';
import { useParams } from 'react-router-dom';
import { z } from 'zod';

import { CreditAgreementsViewTemplate } from '../../../packages/creditAgreements/ui/creditAgreementWip/CreditAgreementsViewTemplate';
import { dashboardRoutePadding } from 'packages/common-frontend/constants';
import CreditAgreement from 'packages/creditAgreements/ui/CreditAgreementView';
import { useUserAuthOrThrow } from '~/contexts/UserAuthProvider';

// Types
const RouteParamsStruct = z.object({
  creditAgreementId: z.string({ message: 'Missing URL parameter' }),
});

// Exports
export const CreditAgreementRoute = () => {
  const { user } = useUserAuthOrThrow();
  const params = useParams();
  const { creditAgreementId } = RouteParamsStruct.parse(params);
  return (
    <Box padding={dashboardRoutePadding}>
      <CreditAgreementsViewTemplate disableSelectors>
        <CreditAgreement
          organizationId={user.organizationId}
          creditAgreementId={creditAgreementId}
          creditAgreementsPath="/credit-agreements"
        />
      </CreditAgreementsViewTemplate>
    </Box>
  );
};
